module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/symbol-observable/index.js
// module id = 862
// module chunks = 7